export default __webpack_public_path__ + "static/media/pro_1.16960506.jpg";